export const namespace = 'restrictedtrades'
